import './MiniProgramTips.less';

export const prefix = 'bm-c-mini-program-tips';

export { default } from './MiniProgramTips';
